import React from 'react';
import { CompositeDecorator } from 'draft-js';
import styled from 'styled-components';

const MentionedName = styled.span`
  color: #0076ea;
  border-radius: 2px;
  background-color: ${(props) =>
    props.defaultChecked ? '#fff9e5' : '#e8f5fa'};
  cursor: pointer;
`;

const LinkUrl = styled.a`
  color: #0076ea;
  cursor: pointer;
`;

// find entity with passed-in type.
const findEntities = (
  entityType: string,
  contentBlock: any,
  callback: any,
  contentState: any,
) => {
  contentBlock.findEntityRanges((character: any) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === entityType
    );
  }, callback);
};

const findWithRegex = (keyword: string, contentBlock: any, callback: any) => {
  const text = contentBlock.getText();

  const matches = [...text.matchAll(keyword)];
  matches.forEach((match) =>
    callback(match.index, match.index + match[0].length),
  );
};

// Mention Component
const mention = ({ contentState, entityKey, children, clickMention }: any) => {
  const profile = contentState.getEntity(entityKey).getData();
  const profileId = localStorage.getItem('kubit:profile_id');
  return (
    <MentionedName
      onClick={() => clickMention && clickMention(profile.id)}
      // give different style when mention user self.
      defaultChecked={profile.id === profileId}
    >
      {children}
    </MentionedName>
  );
};

// Link Component
const link = ({ contentState, entityKey, children }: any) => {
  const { url } = contentState.getEntity(entityKey).getData();
  return (
    <LinkUrl target="_blank" href={url}>
      <u>{children}</u>
    </LinkUrl>
  );
};

// Highlight Component
const highlight = ({ children }: any) => {
  return <span className={'highlight'}>{children}</span>;
};

// return editor decorator after compose.
export const editorDecorator = ({ clickMention, keyword }: any) =>
  new CompositeDecorator([
    {
      // find mention entity, and decorate it with Mention.
      strategy: (contentBlock, callback, contentState) =>
        findEntities('MENTION', contentBlock, callback, contentState),
      component: mention,
      props: { clickMention },
    },
    {
      // find link entity, and decorate it with Link
      strategy: (contentBlock, callback, contentState) =>
        findEntities('LINK', contentBlock, callback, contentState),
      component: link,
    },
    {
      strategy: (contentBlock, callback) =>
        findWithRegex(keyword, contentBlock, callback),
      component: highlight,
    },
  ]);
